import * as React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ActionPlanView from './components/ActionPlanView';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';

export default function ActionPlanPage(): JSX.Element {
    
    const params = useParams<{ actionPlanId: string }>();
    
    return (
        <UserPageWrapper>
            <InnerActionPlanPage actionPlanId={params.actionPlanId} />
        </UserPageWrapper>
    );
}

type InnerActionPlanPageProps = {
    actionPlanId: string;
}
function InnerActionPlanPage(props:InnerActionPlanPageProps):JSX.Element
{
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const returnDestination = queryParams.get('retdist');
    const returnId = queryParams.get('retid');

    const [redirectToList, setRedirectToList] = React.useState(false);

    const activeUser = React.useContext(ProtectedPageContext).user;

    function handleDeleted()
    {
        setRedirectToList(true);
    }

    let returnUrl = '/actionplans';
    if(activeUser?.permissionGroupId === 'user')
    {
        returnUrl = `/user/overview`;            
    }
    else {
        if (returnDestination === 'workplaceassessment') {
            returnUrl = `/workplaceassessments/${returnId ?? ''}`;
        } 
        else if (returnDestination === 'article') {
            returnUrl = `/articles/${returnId ?? ''}`;
        }
        else if (returnDestination === 'dashboard') {
            returnUrl = `/dashboard`;
        }
    }

    return (
        <>
            {redirectToList &&
                <Navigate to={`/actionplans`} replace />
            }

            <SingleColumnLayout
                noDivider
                wide
                contentContainer={
                    <>
                    {props.actionPlanId 
                        ? <ActionPlanView 
                                actionPlanId={props.actionPlanId}
                                backLink={{ text: 'Tilbage til oversigten', url:returnUrl }}
                                onBack={handleDeleted} />
                        : <span>ugyldig url</span>
                    }
                    </>
                } 
            />
        </>
    );
}
